import { Pill, tokens, Typography } from "@sunrun/experience-ui-components";
import styled from "@emotion/styled/macro";
import { ReviewFinancialSummary } from "../../../amplify/backend/function/offerexpstoreFrontApi/ts/public/offerTypes";

type OfferMessagesProps = {
  summary: ReviewFinancialSummary;
  hasBattery: boolean;
};

const OfferMessages = ({ summary, hasBattery }: OfferMessagesProps) => {
  const isTexas = summary.state === "TX";
  const isFlexMonthly = summary.type === "FlexMonthly";

  return (
    <OfferMessagesWrapper>
      {isTexas && hasBattery && !isFlexMonthly && (
        <RepPlanPill type="info" hideIcon>
          <Typography color={tokens.INFO_20} style={{ textWrap: "wrap" }}>
            Get the most out of your system by enrolling in{" "}
            <b>Reliant Truly Free Nights 100% Solar</b> REP Plan.
          </Typography>
        </RepPlanPill>
      )}
      {isTexas && isFlexMonthly && (
        <RepPlanPill type="info" hideIcon>
          <Typography color={tokens.INFO_20} style={{ textWrap: "wrap" }}>
            Get the most out of your system by enrolling in{" "}
            <b>Tesla Electric + Sunrun Flex</b> REP Plan.
          </Typography>
        </RepPlanPill>
      )}
    </OfferMessagesWrapper>
  );
};

const OfferMessagesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

const RepPlanPill = styled(Pill)`
  width: 100% !important;
`;

export { OfferMessages };
